module.exports = __webpack_public_path__ + "static/media/V2_03.5a5716ea.png";